<template>
    <transition name="fade">
        <div class="add-soft-wrapper" v-if="s_soft_add_open">
            <div class="add-soft-name">
                <i @click.stop.prevent="s_soft_add_open = false" class="fa fa-mavon-times" aria-hidden="true"></i>
                <h3 class="title">添加仿真软件</h3>
                <el-form class="softForm" ref="softForm" :model="soft" size="small" label-width="120px">
                    <el-form-item label="仿真软件: ">
                        <el-select v-model="soft.id" placeholder="请选择仿真软件" @change="handleSoftChange">
                            <el-option v-for='tempsfot in softList' :key='tempsfot.id' :label="tempsfot.description" :value='tempsfot.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启动模式: ">
                        <el-select v-model.number="soft.mode" placeholder="请选择启动模式">
                            <!-- <el-option label="本地启动" :value="1"></el-option> -->
                            <el-option label="远程启动" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="案例: ">
                        <el-select v-model="soft.caseUid" filterable placeholder="请选择案例">
                            <el-option v-for="aCase in cases" :key="aCase.uid" :label="aCase.name" :value="aCase.uid"></el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="curApppramaParams">
                        <p>软件启动参数: </p>
                        <el-form-item v-for='list in curApppramaParams' :key="list.key" :label="`${list.name}: `">
                            <el-select v-model="list.value" :placeholder="`请选择${list.name}`">
                                <el-option v-for='(spec) in list.specs' :key='spec.value' :label="spec.display" :value='spec.value'></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-form>
                <div class="op-btn cancel" @click.stop="s_soft_add_open = false">取消</div>
                <div class="op-btn sure" @click.stop="$softadd()">确定</div>
            </div>
        </div>
    </transition>
</template>

<script type="text/ecmascript-6">
import { selectSoftList } from '@/api/exp/expsoftware'
import { getExpList } from '@/api/exp/expcourse2case'
let softInfo = {
    id: null,
    name: '',
    mode: null,
    icon: '',
    appprama: null
}
export default {
    name: 'selectsoft',
    data () {
        return {
            softList: [],
            cases: [], // 案例列表
            s_soft_add_open: false,
            soft_list_mode: null,
            soft: {
                ...softInfo
            }
        }
    },
    props: {
        courseId: {
            type: Number
        }
    },
    watch: {
        s_soft_add_open: {
            deep: true,
            immediate: true,
            handler: function (newVal) {
                if (newVal && this.softList.length === 0) {
                    this.getSofts()
                }
            }
        }
    },
    computed: {
        curSoft () {
            let arr = this.softList.filter(item => item.id === this.soft.id)
            if (arr.length < 1) {
                return null
            }
            return arr[0]
        },
        curCase () {
            let arr = this.cases.filter(item => item.uid === this.soft.caseUid)
            if (arr.length < 1) {
                return null
            }
            return arr[0]
        },
        curApppramaParams () {
            return this.curSoft ? this.curSoft.appprama.params : null
        }
    },
    methods: {
        getSofts () {
            selectSoftList().then(res => {
                if (res) {
                    this.softList = res
                }
            })
        },
        $softaddshow () {
            this.soft = { ...softInfo }
            this.s_soft_add_open = true
        },
        $softadd () {
            this.s_soft_add_open = false
            var jsonData = {}
            if (this.soft.id != null) {
                this.softList.forEach(tempsoft => {
                    if (this.soft.id == tempsoft.id) {
                        tempsoft.appprama.params.forEach(pa => {
                            jsonData[pa.key] = pa.value
                        })
                        this.soft.id = tempsoft.id
                        this.soft.name = tempsoft.name
                        this.soft.icon = tempsoft.icon
                        this.soft.appprama = jsonData
                        return
                    }
                })
            }
            this.$emit('addsoft', {
                ...this.soft,
                softInfo: this.curSoft,
                caseInfo: this.curCase
            })
        },
        handleSoftChange () {
            delete this.soft.caseUid
            this.getCaseList()
        },
        // 获取案例列表（指定课程、软件）
        getCaseList (params = {}) {
            const { courseId, curSoft } = this
            let softId = curSoft.id
            getExpList(null, null, {
                ...params,
                courseId,
                softId
            }).then(res => {
                try {
                    const { list } = res
                    this.cases = list
                } catch (err) {
                    this.cases = []
                    window.console.error(err)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.softForm {
    text-align: initial;
}
.add-soft-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1600;
    transition: all 0.1s linear 0s;

    &.fade-enter-active,
    &.fade-leave-active {
        opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-active {
        opacity: 0;
    }

    .add-soft-name {
        position: fixed;
        box-sizing: border-box;
        text-align: center;
        width: 24%;
        left: 38%;

        @media only screen and (max-width: 1500px) {
            width: 34%;
            left: 33%;
        }

        @media only screen and (max-width: 1000px) {
            width: 50%;
            left: 25%;
        }

        @media only screen and (max-width: 600px) {
            width: 80%;
            left: 10%;
        }

        height: auto;
        padding: 40px;
        top: 25%;
        transition: all 0.1s linear 0s;
        z-index: 3;
        background: #fff;
        border-radius: 2px;
        box-shadow: 0 0px 5px rgba(255, 255, 255, 0.156863),
            0 0px 5px rgba(255, 255, 255, 0.227451);

        i {
            font-size: 24px;
            position: absolute;
            right: 8px;
            top: 6px;
            color: rgba(0, 0, 0, 0.7);
            cursor: pointer;
        }

        .title {
            font-size: 20px;
            margin-bottom: 30px;
            margin-top: 10px;
            font-weight: 500 !important;
        }

        select {
            width: 70%;
        }

        .soft-wrapper {
            height: auto;
            margin-top: 10px;
            margin-left: 10%;
            text-align: left;

            .label-text {
                margin-top: 0px;
            }

            .input-wrapper {
                margin-left: 0%;
                width: 90%;

                select {
                    width: 70%;
                }
            }
        }

        .input-wrapper {
            margin-top: 10px;
            width: 80%;
            border: 1px solid #eeece8;
            text-align: left;
            margin-left: 10%;
            height: 35px;

            input {
                height: 32px;
                line-height: 32px;
                font-size: 15px;
                width: 90%;
                margin-left: 8px;
                border: none;
                outline: none;
            }
        }

        .op-btn {
            $height: 35px;
            width: 100px;
            height: $height;
            display: inline-block;
            margin-top: 30px;
            cursor: pointer;
            text-align: center;
            line-height: $height;
            opacity: 0.9;
            border-radius: 2px;
            letter-spacing: 1px;
            font-size: 15px;
        }

        .op-btn.sure {
            background: #2185d0;
            color: #fff;
            margin-left: 5%;

            &:hover {
                opacity: 1;
            }
        }

        .op-btn.cancel {
            border: 1px solid #bcbcbc;
            color: #bcbcbc;

            &:hover {
                color: #000;
            }
        }
    }
}
</style>

